import useTranslation from 'next-translate/useTranslation'

import FloatBox from '@/organisms/FloatBox'
import { DeliveryAddress } from '@/ts/Global'

function DeliveryAddressBox({ deliveryAddress }: DeliveryAddressProps) {
  const { t } = useTranslation('products')

  return (
    <FloatBox className="max-h-full space-y-1">
      <p className="mb-4 text-xl text-black/80">{t('order_deliver_address')}</p>
      <p className="md:text-lg text-black/60">
        {deliveryAddress?.first_name} {deliveryAddress?.last_name}
      </p>
      <p className="md:text-lg text-black/60">
        {deliveryAddress?.phone_number}
      </p>
      <p className="md:text-lg text-black/60">
        {deliveryAddress?.street_name} {deliveryAddress?.house_and_flat_number}
      </p>
      <p className="md:text-lg text-black/60">
        {deliveryAddress?.post_code} {deliveryAddress?.city}
      </p>
      <p className="md:text-lg text-black/60">{deliveryAddress?.country}</p>
    </FloatBox>
  )
}

interface DeliveryAddressProps {
  deliveryAddress: DeliveryAddress
}

export default DeliveryAddressBox
